import { Check } from "lucide-react";
import { cn } from "../../lib/utils";
import { descriptionLines } from "./types";

interface ProductDescriptionProps {
  description: string | null;
  /** Show at most this many points, then "+N more". Omit to show all. */
  limit?: number;
  className?: string;
}

/**
 * One line reads as a sentence; several lines read as a checklist of what the
 * product includes.
 */
export function ProductDescription({ description, limit, className }: ProductDescriptionProps) {
  const lines = descriptionLines(description);

  if (lines.length === 0) {
    return <p className={cn("text-sm italic text-ink-3", className)}>No description provided.</p>;
  }
  if (lines.length === 1) {
    return (
      <p className={cn("text-sm leading-relaxed text-ink-2", limit !== undefined && "line-clamp-3", className)}>
        {lines[0]}
      </p>
    );
  }

  const shown = limit === undefined ? lines : lines.slice(0, limit);
  const hidden = lines.length - shown.length;
  return (
    <div className={className}>
      <ul className="space-y-2">
        {shown.map((line, i) => (
          <li key={i} className="flex items-start gap-2.5 text-sm leading-snug text-ink-2">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-success" aria-hidden />
            <span>{line}</span>
          </li>
        ))}
      </ul>
      {hidden > 0 && <p className="mt-2 pl-[26px] text-xs font-medium text-ink-3">+{hidden} more</p>}
    </div>
  );
}
